import React from "react";
import html2canvas from "html2canvas";
import "./IdCard.css";
import shani from "./shani.png";
import sign from "./signature.png";

const IdCard = () => {
    const saveCardAsImage = (selector, filename) => {
        const card = document.querySelector(selector);

        html2canvas(card, {
            scale: 3,
            backgroundColor: null,
            useCORS: true,
        }).then((canvas) => {
            const link = document.createElement("a");
            link.download = filename;
            link.href = canvas.toDataURL("image/png");
            link.click();
        });
    };

    return (
        <div className="page">
            {/* Horizontal Card */}
            <div className="id-card horizontal">
                {/* Header */}
                <div className="header">
                    <div className="logo">
                        <img src="/numl.png" alt="NUML Logo" crossOrigin="anonymous" />
                    </div>
                    <div className="meow">
                        <div className="header-text">
                            NATIONAL UNIVERSITY OF MODERN LANGUAGES
                        </div>
                        <div className="sub-header">Lahore Campus</div>
                    </div>
                </div>

                {/* Contact */}
                <div className="contact">
                    <div className="tel">Tel: 042-99204588</div>
                    <div className="web">www.numl.edu.pk</div>
                </div>

                {/* Info */}
                <div className="info">
                    <div className="details">
                        <div>
                            <b>Name:</b> Muhammad Zeeshan Sarfraz
                        </div>
                        <div>
                            <b>Class:</b> BSCS
                        </div>
                        <div>
                            <b>SYS ID:</b> NUML-S24-32247
                        </div>
                        <div>
                            <b>Session:</b> Feb-2024 to Jan-2028
                        </div>
                        <div>
                            <b>CNIC #:</b> 38404-2215877-3
                        </div>
                    </div>
                    <div className="photo">
                        <img src={shani} alt="Student" crossOrigin="anonymous" />
                    </div>
                </div>

                {/* Footer */}
                {/* Footer with Signature (Horizontal) */}
                <div className="footer">
                    <div className="signature">
                        <img src={sign} alt="Signature" crossOrigin="anonymous" />
                    </div>
                    Regional Director‎ ‎ ‎ ‎‎‎
                </div>

            </div>

            {/* Buttons */}
            <div className="actions">
                <button className="print-btn" onClick={() => window.print()}>
                    🖨️ Print Both Cards
                </button>
                <button
                    className="print-btn"
                    onClick={() => saveCardAsImage(".horizontal", "id-card-horizontal.png")}
                >
                    💾 Save Horizontal
                </button>
                <button
                    className="print-btn"
                    onClick={() => saveCardAsImage(".vertical", "id-card-vertical.png")}
                >
                    💾 Save Vertical
                </button>
            </div>

            {/* Vertical Card */}
            <div className="id-card vertical">
                <div className="header vertical-header">
                    <div className="logo">
                        <img src="/numl.png" alt="NUML Logo" crossOrigin="anonymous" />
                    </div>
                    <div className="header-text">
                        NATIONAL UNIVERSITY OF MODERN LANGUAGES
                    </div>
                    <div className="sub-header">Lahore Campus</div>
                </div>

                <div className="photo vertical-photo">
                    <img src={shani} alt="Student" crossOrigin="anonymous" />
                </div>

                <div className="details vertical-details">
                    <div>
                        <b>Name:</b> Muhammad Zeeshan Sarfraz
                    </div>
                    <div>
                        <b>Class:</b> BSCS
                    </div>
                    <div>
                        <b>SYS ID:</b> NUML-S24-32247
                    </div>
                    <div>
                        <b>Session:</b> Feb-2024 to Jan-2028
                    </div>
                    <div>
                        <b>CNIC #:</b> 38404-2215877-3
                    </div>
                </div>

                {/* Footer with Signature (Vertical) */}
                <div className="footer">
                    <div className="signature">
                        <img src={sign} alt="Signature" crossOrigin="anonymous" />
                    </div>
                    Regional Director ‎
                </div>

            </div>
        </div>
    );
};

export default IdCard;
